import React, { useState } from 'react';
interface QueryCategory {
  name: string;
  count: number;
  percentage: number;
  color: string;
}
const QUERY_CATEGORIES: QueryCategory[] = [{
  name: 'Sales',
  count: 67950,
  percentage: 66.7,
  color: '#1e1b4b'
}, {
  name: 'Service',
  count: 6900,
  percentage: 6.8,
  color: '#22c55e'
}, {
  name: 'Feedback',
  count: 23780,
  percentage: 23.3,
  color: '#b91c1c'
}, {
  name: 'Non Sales',
  count: 3220,
  percentage: 3.2,
  color: '#f97316'
}];
const QUERY_DETAILS = [{
  name: 'Appointment Cancellation approval',
  count: 289,
  percentage: 0.4
}, {
  name: 'Appointed Enquiry',
  count: 5523,
  percentage: 8.1
}, {
  name: 'Approaching Enquiry Cancel',
  count: 150,
  percentage: 0.2
}, {
  name: 'Achievement',
  count: 349,
  percentage: 0.5
}, {
  name: 'Booking',
  count: 335,
  percentage: 0.5
}, {
  name: 'Booking Cancel',
  count: 14,
  percentage: 0.0
}, {
  name: 'Enquiry Cancel',
  count: 2363,
  percentage: 3.5
}, {
  name: 'Enquiry cancellation approval',
  count: 1396,
  percentage: 2.1
}, {
  name: 'Enquiry Follow up',
  count: 20558,
  percentage: 30.3
}, {
  name: 'Enquiry Follow up Cancel',
  count: 973,
  percentage: 1.4
}, {
  name: 'Invoiced',
  count: 44,
  percentage: 0.1
}, {
  name: 'Invoiced Cancel',
  count: 1,
  percentage: 0.0
}, {
  name: 'Lease',
  count: 23432,
  percentage: 34.5
}, {
  name: 'Retail',
  count: 18,
  percentage: 0.0
}, {
  name: 'Undecided Lp',
  count: 1,
  percentage: 0.0
}];
export function LeadQueryOverview() {
  const [showFormLeads, setShowFormLeads] = useState(true);
  const [showCallLeads, setShowCallLeads] = useState(true);
  const totalCount = QUERY_CATEGORIES.reduce((sum, cat) => sum + cat.count, 0);
  const maxDetailCount = Math.max(...QUERY_DETAILS.map(d => d.count));
  return <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1067">
      <div className="flex items-center justify-between mb-6" data-id="element-1068">
        <h3 className="text-base font-semibold text-gray-900" data-id="element-1069">
          Lead Query Overview
        </h3>
        <div className="flex items-center space-x-4 text-sm" data-id="element-1070">
          <label className="flex items-center cursor-pointer" data-id="element-1071">
            <input type="checkbox" checked={showFormLeads} onChange={e => setShowFormLeads(e.target.checked)} className="mr-2 rounded text-blue-600 focus:ring-blue-500" data-id="element-1072" />
            <span className="text-gray-700" data-id="element-1073">Form Leads</span>
          </label>
          <label className="flex items-center cursor-pointer" data-id="element-1074">
            <input type="checkbox" checked={showCallLeads} onChange={e => setShowCallLeads(e.target.checked)} className="mr-2 rounded text-blue-600 focus:ring-blue-500" data-id="element-1075" />
            <span className="text-gray-700" data-id="element-1076">Call Leads</span>
          </label>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6" data-id="element-1077">
        {/* Left: Donut Chart */}
        <div className="flex flex-col items-center justify-center" data-id="element-1078">
          <div className="relative w-64 h-64" data-id="element-1079">
            <svg className="w-full h-full transform -rotate-90" data-id="element-1080">
              {QUERY_CATEGORIES.map((category, index) => {
              const prevPercentages = QUERY_CATEGORIES.slice(0, index).reduce((sum, cat) => sum + cat.percentage, 0);
              const radius = 80;
              const circumference = 2 * Math.PI * radius;
              const offset = prevPercentages / 100 * circumference;
              const length = category.percentage / 100 * circumference;
              return <circle key={category.name} cx="128" cy="128" r={radius} fill="none" stroke={category.color} strokeWidth="40" strokeDasharray={`${length} ${circumference - length}`} strokeDashoffset={-offset} className="transition-all duration-500" data-id="element-1081" />;
            })}
            </svg>
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-1082">
              <div className="text-center" data-id="element-1083">
                <div className="text-3xl font-bold text-gray-900" data-id="element-1084">
                  {(totalCount / 1000).toFixed(2)}K
                </div>
              </div>
            </div>
          </div>

          {/* Legend */}
          <div className="grid grid-cols-2 gap-x-6 gap-y-2 mt-6" data-id="element-1085">
            {QUERY_CATEGORIES.map(category => <div key={category.name} className="flex items-center text-xs" data-id="element-1086">
                <div className="w-3 h-3 rounded-sm mr-2" style={{
              backgroundColor: category.color
            }} data-id="element-1087"></div>
                <span className="text-gray-700 font-medium" data-id="element-1088">
                  {category.name}
                </span>
                <span className="ml-auto text-gray-500" data-id="element-1089">
                  {category.count.toLocaleString()}
                </span>
              </div>)}
          </div>
        </div>

        {/* Right: Bar Chart */}
        <div className="space-y-2" data-id="element-1090">
          {QUERY_DETAILS.map((detail, index) => <div key={index} className="flex items-center text-xs" data-id="element-1091">
              <div className="w-32 text-gray-600 truncate" title={detail.name} data-id="element-1092">
                {detail.name}
              </div>
              <div className="flex-1 mx-3" data-id="element-1093">
                <div className="h-8 bg-gray-100 rounded overflow-hidden relative" data-id="element-1094">
                  <div className="h-full bg-blue-400 transition-all duration-500 flex items-center justify-end pr-2" style={{
                width: `${detail.count / maxDetailCount * 100}%`
              }} data-id="element-1095">
                    {detail.count > 1000 && <span className="text-white font-medium text-[10px]" data-id="element-1096">
                        {detail.count.toLocaleString()}
                      </span>}
                  </div>
                  {detail.count <= 1000 && <div className="absolute inset-0 flex items-center justify-end pr-2" data-id="element-1097">
                      <span className="text-gray-600 font-medium text-[10px]" data-id="element-1098">
                        {detail.count.toLocaleString()}
                      </span>
                    </div>}
                </div>
              </div>
              <div className="w-16 text-right text-gray-500" data-id="element-1099">
                ({detail.percentage.toFixed(1)}%)
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}